import React from "react";
import { Wrapper } from "@/components";
import SpotifyCodeFilm from "../spotify-code-film";
import { MultiPhotoProps } from "../factory";
import styles from "./index.less";

const DoubleDesign: React.FC<MultiPhotoProps> = (props) => {
  return (
    <Wrapper position="fixed" className={styles.doubleDesign}>
      <SpotifyCodeFilm {...props} />
    </Wrapper>
  );
};

export default DoubleDesign;
